import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xs" }

import { useI18n } from 'vue-i18n'

interface Props {
  status: string
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ReferenceStatus'
},
  __name: 'ReferenceStatus',
  props: {
    status: {}
  },
  setup(__props: any) {





const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createTextVNode(_toDisplayString(_unref(t)('general.status')) + ": ", 1),
    _renderSlot(_ctx.$slots, "default", { status: __props.status }, () => [
      _createElementVNode("span", null, _toDisplayString(__props.status), 1)
    ])
  ]))
}
}

})